import {
  HttpErrorResponse,
  HttpEventType,
  HttpInterceptorFn,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, tap, throwError } from 'rxjs';
import { ConnectionUnavailableScreenService } from '../services/connection-unavailable-screen.service';

export const connectionUnavailableInterceptor: HttpInterceptorFn = (req, next) => {
  const connectionUnavailableScreenService = inject(ConnectionUnavailableScreenService);

  return next(req).pipe(
    tap((event) => {
      if (event.type === HttpEventType.Response) {
        connectionUnavailableScreenService.hideConnectionUnavailable();
      }
    }),
    catchError((error: HttpErrorResponse) => {
      if (connectionUnavailableScreenService.isConnectionUnavailableError(error)) {
        connectionUnavailableScreenService.showConnectionUnavailable();
      }

      return throwError(() => error);
    })
  );
};
